import Vue from "vue";
import ConfirmModal from "@/components/modals/ConfirmModal";
import ExtendSession from "@/components/modals/ExtendSession";
import PlanExpired from "@/components/modals/PlanExpired";
import Connector from "@/assets/js/connector.js";
import router from "../router";
import VariableHelpers from "@/assets/js/variableHelpers.js";
import SynonymHelpers from "@/assets/js/synonymHelpers.js";
import i18n from "../i18n";
import Template from "@/assets/js/template.js";
import appHelper from "../assets/js/appHelper";
import demoHelper from "../assets/js/demoHelper";

export default {
    cloneScenarioGroup({ state }, data) {
      let clones = [];
      state.templateSectionBeingEdited
        .findSentenceListById(data.sentenceListId)
        .sentences.filter((s) => s.number == data.number)
        .forEach((s) => {
          let clone = s.clone();
          clone.oldId = s.id;
          clones.push(clone);
        });
      return clones;
    },

    cloneScenario({ state }, data) {
      return state.templateSectionBeingEdited
        .findSentenceListById(data.sentenceListId)
        .getById(data.sentenceId)
        .clone();
    },

    getTemplateData({ state, dispatch, commit }, templateId) {
      return new Promise((resolve, reject) => {
        // commit('setTemplateData', { template, variables })
        let template = state.templates.find((t) => t.id == templateId);
        if (!template) {
          reject("notfound");
        } else {
          Promise.all([dispatch("getTemplate", template.id), dispatch("getVariables", { template })]).then(
            (results) => {
              dispatch("getVariableFormats", {templateLanguage: results[0].language}).then(() => {
                commit("setTemplateData", {
                  template: results[0],
                  variables: results[1],
                });
                dispatch("getTemplatePreview", {
                  template: state.template,
                  variables: state.templateVariables,
                  // generateAIContent: true
                }).then((preview) => {
                  dispatch("getTemplateBackups", templateId),
                  dispatch("getTemplatePreviewForSectionType", "ai"),
                    // dispatch("getFavorites")
                    (state.templatePreview = preview);
                  dispatch("getFavorites");
                  resolve(preview);
                });
              })
              
            },
            reject,
          );
        }
      });
    },

    getTemplate({ state }, templateId) {
      // return new Promise((resolve, reject) => {
      //   resolve(templateFile)
      // })
      return Vue.http.get("templates/" + templateId).then((result) => result.body);
    },

    getVariables({ state, dispatch }, { template, id, isDemo }) {
      return Vue.http
        .get(`templates/${isDemo ? template.metadata.id : template.id}/metadata/variables` + (id ? `?contentId=${encodeURIComponent(id)}` : ""))
        .then((result) => result.body);
    },

    updateTemplateMethods({ state, dispatch }, updatedMethods) {
      dispatch("getTemplate", state.template.metadata.id).then((r) => {
        r.methods = updatedMethods;
        return Vue.http
          .put("templates/" + state.template.metadata.id, r)
      });
    },

    saveTemplateChanges({ state, dispatch }, isDemo) {
      return Vue.http.put("templates/" + state.template.metadata.id, state.template.export()).then(() => {
        state.unsavedChanges = false;
        if (!isDemo) dispatch("getTemplateBackups", state.template.metadata.id);
      });
    },

    saveTemplateFromSignupFlow({ state, dispatch }, template) {
      return Vue.http.put(`templates/${template.metadata.id}`, template)
    },

    getSentencePreview({ state }, sentence) {
      // first ignore the first condition
      let template = {
        metadata: state.template.metadata,
        extraVariables: state.template.extraVariables,
        globalSynonyms: state.template.globalSynonyms,
        methods: state.template.methods,
        sections: [{ sentences: [{ texts: [sentence] }], name: "Body", id: "body" }],
        language: state.template.language,
      };
      return Vue.http
        .post("editor/previewtemplate?includeVariableNames=false", {
          template: template,
          variables: state.templateVariables,
        })
        .then((result) => {
          return result.body.sections[0].result ? result.body.sections[0].result.sentences : null;
        });
    },

    getTemplatePreview({ state, dispatch }, { template, variables, includeVariableNames = !state.templatePreviewAsHTML, generateAIContent = false}) {
      let seed = router.currentRoute ? router.currentRoute.query.seed || null : null;
      return Vue.http
        .post(
          "editor/previewtemplate?includeVariableNames=" + includeVariableNames + (seed ? "&seed=" + seed : "") + ("&generateAIContent=" + generateAIContent),
          { template: template.export(), variables: variables },
          // { template: !backupPreview ? template.export() : template, variables: variables }
        )
        .then((result) => result.body);
    },


    getTemplatePreviewForSectionType({state, dispatch, commit}, type){
      const templateContent = new Template({...state.template, sections: state.template.sections.filter(s => s.type == type)})
      templateContent.sections.forEach(s => commit("aiSectionLoading", s.id))
      dispatch("getTemplatePreview", {
        template: templateContent,
        variables: state.templateVariables,
        generateAIContent: true
      }).then(preview => {
        commit("setTemplatePreview", preview)
        templateContent.sections.forEach(s => commit("aiSectionLoaded", s.id))
      })
    },
    
    getTemplatePreviewForSection({state, dispatch, commit}, sectionId){
      const templateContent = new Template({...state.template, sections: state.template.sections.filter(s => s.id == sectionId)})
      commit("aiSectionLoading", sectionId)
      dispatch("getTemplatePreview", {
        template: templateContent ,
        variables: state.templateVariables,
        generateAIContent: true
      }).then((preview) => {
        commit("aiSectionLoaded", sectionId)
        commit("setTemplatePreview", preview)
      }).catch((e) => {
        commit("aiSectionLoaded", sectionId)
        commit("aiSectionPreviewError", sectionId)
      })
    },

    refreshAllPreviews({state, dispatch}){
      state.templateMultiplePreview.forEach((preview) => {
        preview.loading = true; 
        dispatch("getTemplatePreview", {
          template: state.template,
          variables: preview.variables,
          generateAIContent: true
          })
          .then((newPreview) => {
            preview.preview = newPreview;
            preview.loading = false;
          });
      });
    },

    variableClicked({ state }, { node, variable, clickEvent }) {
      if (state.activeTextEditor) {
        state.activeTextEditor.$emit("variable-clicked", {
          node,
          variable,
          event,
        });
      }
    },

    testExpression({ state, getters }, expression) {
      return Vue.http
        .post("editor/expressions/check", {
          expression: expression,
          dependentVariables: VariableHelpers.getDependentVariables(expression, getters.combinedVariables).reverse(), // Reverse - then checking the expressions also works if the users uses extravariables in extravariables
        })
        .then((result) => result.body);
    },

    setActivePath({ state, dispatch }, path) {
      // console.log("active path set: " + path);
      Vue.set(state, "activePath", path);
    },

    cleanUpTemplate({ state }, template) {
      // clean up a template
    },

    setCategoryFilter({ state, commit }) {
      if (state.filters.length <= 1) {
        state.contentTypes.map((c) => {
          let filter = {
            name: c.name,
            id: c.id,
            categories: [c.name],
            custom: c.custom,
          };
          state.filters.push(filter);
        });
      }
    },

    signUp({ state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations", data)
          .then(() => {
            const loginDetails = {
              email: data.user.username,
              password: data.user.password,
            };
            router.push("login");
            dispatch("logIn", loginDetails).then((res) => {
              router.push("home");
            });
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    signupFromFlow({ state }, data) {
      // Add params to the url for backend to send slack message about what type of setup the user initially requested
      const params = []
      Object.keys(data.params).forEach((key) => {
        if (data.params[key]) {
          params.push(key + "=" + data.params[key])
        }
      })
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`organizations${params.length ? '?'+ params.join('&') : ''}`, data.userInfo).then((res) => {
            resolve(true);
          })
          .catch((error) => {
            console.log("error", error)
            reject(error);
          });
        // resolve(true);
      });
    },

    endSignupFlow({ state }, messageType) {
      // MessageType either "AI", "Standard" or "NoIntegration"
      return Vue.http.get(`organizations/me/endsignup/${messageType}`)
    },

    logIn({ state, commit }, { email, password }) {
      return new Promise((resolve, reject) => {
        return Vue.http
          .post("login", { username: email, password: password, grant_type: "password" }, { emulateJSON: true })
          .then((result) => {
            commit("setToken", result.body);
            resolve(true);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    logOut({ state }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("token");
        Vue.delete(state, "user", null);
        Vue.delete(state, "token", null);
        resolve();
      });
    },

    handleExpiredToken({ state }) {
      if (!state.handlingExpiredToken) {
        state.handlingExpiredToken = true;
        let modal = this._vm.$modal;
        modal.show(
          ExtendSession,
          {
            title: i18n.t("extend-session.title"),
            description: i18n.t("extend-session.description"),
            confirmButtonText: i18n.t("extend-session.button"),
            userDetails: state.user,
          },
          { width: 450, height: "auto", adaptive: true, clickToClose: false },
        );
      }
    },

    handleExpiredPlan({ state }) {
      if (router.currentRoute.name == "template" && state.unsavedChanges) {
        // console.log("editing a template & changes are made");
      }
      let modal = this._vm.$modal;
      modal.show(
        PlanExpired,
        {
          title: i18n.t("expired.title"),
          description: i18n.t("expired.description"),
          showSavingOptions: router.currentRoute.name == "template" && state.unsavedChanges,
        },
        { width: 450, height: "auto", adaptive: true, clickToClose: false },
      );
    },
    getUser({ state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        if (state.user) resolve(state.user);
        else {
          Vue.http.get("users/me").then((res) => { state.user = (res.body)
          const storedLanguage = localStorage.getItem("language-storage") || "en";
          const getUserLanguage = appHelper.getCountryCode(res.body.language);
            if (res.body.language === null) {
              dispatch("changeUserInfo", {language: storedLanguage, name: res.body.name});
            }
            else if (storedLanguage != getUserLanguage){
              localStorage.setItem("language-storage", getUserLanguage);
              i18n.locale = getUserLanguage;
            }
            resolve(state.user);
          }); 
        }
      });
    },

    getUsers({ state, commit }, refresh) {
      return new Promise(async (resolve, reject) => {
        if (!refresh && state.users.length) resolve(state.users);
        else {
          state.users = (await Vue.http.get("organizations/me/users")).body;
          resolve(state.users);
        }
      });
    },

    getApiKeys({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        if (state.apiKeys.length) resolve(state.apiKeys);
        else {
          state.apiKeys = (await Vue.http.get("organizations/me/apikeys")).body;
          resolve(state.apiKeys);
        }
      });
    },

    getScopes({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        if (state.scopes.length) resolve(state.scopes);
        else {
          state.scopes = (await Vue.http.get("organizations/me/apikeys/scopes")).body.reverse();
          resolve(state.scopes);
        }
      });
    },

    getOrganization({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        if (state.organization) resolve(state.organization);
        else {
          state.organization = (await Vue.http.get("organizations/me")).body;
          resolve(state.organization);
        }
      });
    },

    activateUser({ state }, id) {
      return Vue.http.put(`organizations/me/users/${id}/activate`).then(() => {
        Vue.set(state.users.find((u) => u.id == id), "deactivated", false);
      });
    },

    deactivateUser({ state }, id) {
      return Vue.http.put(`organizations/me/users/${id}/deactivate`).then(() => {
        Vue.set(state.users.find((u) => u.id == id), "deactivated", true);
      });
    },

    addUser({ state }, user) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations/me/users", user, { emulateJSON: true })
          .then((result) => {
            resolve(true);
            state.users.push(result.body);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    addApi({ state }, apiKey) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations/me/apikeys", apiKey, { emulateJSON: true })
          .then((result) => {
            result.body.newApiKey = true;
            state.apiKeys.push(result.body);
            resolve(result.body);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async changePassword({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put("users/me/password", data)
          .then((result) => {
            if (result.body === false) {
              reject(result);
            } else {
              // state.data = result.body;
              resolve(true);
              return result.body;
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    changeUserInfo({ state, dispatch, commit }, user) {
      return new Promise(async (resolve, reject) => {
        Vue.http
          .put("users/me", user)
          .then((result) => {
            commit("updateUserInfo", result.body);
            dispatch("getUsers", true);
            resolve(result.body);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    
    changeOrganizationInfo({ state }, org) {
      return new Promise((resolve, reject) => {
        Vue.http.put("organizations/me", org).then((result) => {
          state.organization = result.body;
          resolve(true);
          return result.body;
        });
      });
    },

    renameApi({ state }, apiKey) {
      let scopes = [];
      Object.keys(apiKey.scopes).forEach((key) => {
        let val = apiKey.scopes[key];
        scopes.push(val.uniqueName);
      });

      let newKeyName = { name: apiKey.name, scopes: scopes };
      newKeyName = JSON.stringify(newKeyName);

      return new Promise((resolve, reject) => {
        Vue.http
          .put("organizations/me/apikeys/" + apiKey.id, newKeyName, {
            emulateJSON: true,
          })
          .then((result) => {
            resolve(true);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    editScopes({ state }, apiKey) {
      const newKeyScopes = { name: apiKey.name, scopes: apiKey.scopes };
      return new Promise((resolve, reject) => {
        Vue.http
          .put("organizations/me/apikeys/" + apiKey.id, JSON.stringify(newKeyScopes), { emulateJSON: true })
          .then((result) => {
            let k = state.apiKeys.find((key) => key.id == apiKey.id);
            k.scopes = result.body.scopes;
            resolve(true);
            // state.apiKeys[state.apiKeys.findIndex(a => a.id == apiKey.id)] = result.body;
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deleteApi({ state, dispatch }, apiKey) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title: i18n.t("delete-modal.delete") + " " + apiKey.name + "?",
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(
          () => {
            Vue.http.delete("organizations/me/apikeys/" + apiKey.id).then(() => {
              state.apiKeys.splice(state.apiKeys.findIndex((t) => t.id == apiKey.id), 1);
              resolve();
            });
          },
          () => {
            reject();
          },
        );
      });
    },

    getTemplates({ state, commit }) {
      return Vue.http.get("templates/metadata").then((result) => {
        state.templates = result.body;
      });
    },

    searchVariables({ state, commit }, { filter, templateId }) {
      return Vue.http
      .get(`templates/${templateId}/search?pageSize=10&query=${encodeURIComponent(filter)}`)
      .then((result) => result.body);
    },

    getVariableFormats({ state, dispatch }, params) {
      const getData = () => {
        return Vue.http.get(`editor/metadata/formats?templateLanguage=${params.templateLanguage}`).then((result) => {
          state.variableFormats = result.body;
          return result.body;
        });
      }
      if(!params.templateLanguage){
        dispatch("getTemplate", params.templateId).then(res => {
              params.templateLanguage = res.language
              getData()
        })
      } else {
        getData()
      }
    },

    getFormatExamples({ getters, state }, { variable, formats }) {
      let dependentVariables = VariableHelpers.getDependentVariables(variable.name, getters.combinedVariables);
      return Vue.http
        .post("editor/variables/format?language=" + state.template.language, {
          dependentVariables,
          variable,
          formats,
        })
        .then((result) => result.body);
    },

    getSynonymFormatExamples({ getters, state }, { synonym, formats, all }) {
      return Vue.http
        .post("editor/synonyms/format?language=" + state.template.language + (all ? "&all=true" : ""), {
          synonym,
          formats,
        })
        .then((result) => result.body);
    },

    publishTemplate({ state }, { publicationName, template, existingPublication }) {
      return Vue.http[existingPublication ? "put" : "post"](
        "templates/" +
          template.id +
          "/publish" +
          (existingPublication ? "/" + existingPublication.id : "?name=" + publicationName.trim()),
      ).then((result) => {
        if (existingPublication) {
          state.templates.splice(state.templates.findIndex((t) => t.id === existingPublication.id), 1, result.body);
        } else state.templates.push(result.body);

        return result.body;
      });
    },

    deleteTemplate({ state, dispatch }, template) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title:
            i18n.t("delete-modal.delete") +
            " " +
            (template.published ? i18n.t("delete-modal.publication") : i18n.t("delete-modal.template")) +
            "?",
          description:
            i18n.t("delete-modal.desc-one") +
            (template.published ? i18n.t("delete-modal.publication") : i18n.t("delete-modal.template")) +
            i18n.t("delete-modal.desc-two"),
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(
          () => {
            Vue.http.delete("templates/" + template.id).then(() => {
              state.templates.splice(state.templates.findIndex((t) => t.id == template.id), 1);

              resolve();
            });
          },
          () => {
            reject();
          },
        );
      });
    },

    createTemplate({ dispatch, commit  }, { templateName, contentType, contentSource, language, standardTemplateId }) {
      return new Promise((resolve, reject) => {
        Vue.http
        .post("templates", {
          name: templateName,
          language: language,
          contentType: contentType,
          sources: contentSource,
          template: {},
          standardTemplateId: parseInt( standardTemplateId )
        })
        .then((result) => {
          commit("addTemplate", result.body.metadata)
          dispatch("addDefaultTemplateSettings", result.body);
          resolve(result.body);
        }).catch((error) => {
          reject(error);
        });

      });
    },


    showConfirmation({commit},{ title, description, confirmButtonText }) {
      let modal = this._vm.$modal;
      return new Promise((resolve, reject) => {
        let confirmed = false;
        modal.show(
          ConfirmModal,
          {
            title: title,
            description: description,
            confirmButtonText: confirmButtonText,
            onConfirm: (result) => {
              confirmed = true;
              resolve(result);
            },
          },
          { width: 310, height: "auto", adaptive: true },
          {
            "before-close": (event) => {
              if (!confirmed) reject();
            },
          },
        );
      });
    },

    getContentSources({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http.get("organizations/me/sources").then((result) => {
          state.contentSources = result.body;
          resolve(state.contentSources);
        });
      });
    },

    getIntegrationSettings({ state }, settings) {
      return new Promise((resolve, reject) => {
        let sources;
        if (settings) {
          sources = settings;
        } else {
          const connectors = state.contentTypes.filter((c) =>
            state.fixedConnectors.map((f) => f.value).includes(c.name),
          );
          sources = connectors.map((c) => c.name);
        }
        Vue.http.post("organizations/me/sources/settings", { sources: sources }).then((result) => {
          if (settings) {
            const settingsKeys = Object.keys(result.body);
            settingsKeys.forEach((setting) => {
              if (!state.connectorSettings[setting]) Vue.set(state.connectorSettings, setting, result.body[setting]);
            });
          } else {
            state.connectorSettings = result.body;
          }
          resolve(result.body);
        });
      });
    },

    createFixedIntegration({ state, dispatch }, { integrationEnumName, settings }) {
      return new Promise((resolve, reject) => {
        let connector = new Connector(
          integrationEnumName,
          state.fixedConnectors.find((c) => c.value == integrationEnumName).name,
        );
        settings.forEach((setting) => {
          if (setting.default) {
            connector.config[setting.id] = setting.default;
          }
        });
        Vue.http
          .post("organizations/me/sources", connector)
          .then((result) => {
            dispatch("getContentTypes", true)
            .then(() => dispatch("getContentSources"))
              .then(() => dispatch("getContentSources2", true))
              .then(() => resolve(result.body));
          })
          .catch((error) => {
            reject(error);
          });
      });
    },


    createConnectorFromSignup({ state, dispatch }, data) {
      return Vue.http.post("organizations/me/sources", data)  
    },

    editFixedIntegration({ state }, integration) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put("organizations/me/sources/" + integration.enumName, integration)
          .then((result) => {
            result.body.fixedIntegration = true;
            resolve(result.body);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deleteFixedIntegration({ state, dispatch }, integration) {
      return new Promise((resolve, reject) => {
          Vue.http
            .delete("organizations/me/sources/" + integration.enumName + "?sourceId=" + integration.id, integration)
            .then(() => {
              // Check if last
              const lastFixed = !state.contentSources.some(
                (source) => source.contentType.id == integration.contentType.id && source.id != integration.id,
              );
              if (lastFixed) {
                state.filters.splice(state.filters.findIndex((f) => f.name == integration.name), 1);
              }
              dispatch("getContentSources")
                .then(() => dispatch("getContentSources2", true))
                .then(() => dispatch("getContentTypes", true));
              resolve(lastFixed);
            })
            .catch((error) => {
              console.log("error", error);
              reject(error);
            });
        
      });
    },

    getContentSources2({ state, commit }, refresh) {
      return new Promise(async (resolve, reject) => {
        if (!refresh && state.contentSources2.length) resolve(state.contentSources2);
        else {
          state.contentSources2 = (await Vue.http.get("contentsources")).body;
          resolve(state.contentSources2);
        }
      });
    },

    getContentSource({ state }, sourceId) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`contentsources/${sourceId}`)
          .then((res) => {
            resolve(res.body);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getDummyData({ state, commit }, contentSource) {
      return new Promise(async (resolve, reject) => {
        await Vue.http.get(`contentsources/${contentSource.id}/dummydata`).then((res) => {
          resolve(res.body);
        });
      });
    },

    getContentTypes({ state, commit }, refresh) {
      return new Promise(async (resolve, reject) => {
        if (!refresh && state.contentTypes.length) resolve(state.contentTypes);
        else {
          state.contentTypes = (await Vue.http.get("contentsources/types")).body;
          resolve(state.contentTypes);
        }
      });
    },

    deleteContentType({ state, dispatch }, contentType) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title: i18n.t("delete-modal.delete") + " " + contentType.name + "?",
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(() => {
          Vue.http
            .delete("contentsources/types/" + contentType.id)
            .then(() => {
              state.contentTypes.splice(state.contentTypes.findIndex((t) => t.id == contentType.id), 1);
              state.filters.splice(state.filters.findIndex((f) => f.name == contentType.name), 1);
              resolve(true);
            })
            .catch((error) => {
              reject(error);
            });
        });
      });
    },

    createContentType({ state, dispatch }, contentType) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("contentsources/types?name=" + contentType, {
            emulateJSON: true,
          })
          .then((result) => {
            let filter = {
              name: result.body.name,
              id: result.body.name.toLowerCase(),
              categories: [result.body.name],
              custom: result.body.custom,
            };
            // state.filters.push(filter);
            // dispatch('setCategoryFilter', true).then(() => resolve(true))
            resolve(result);
            state.contentTypes.push(result.body);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    createSource({ state, dispatch }, contentSource) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("contentsources", contentSource, { emulateJSON: true })
          .then((result) => {
            dispatch("getContentSources2", true).then(() => resolve(true));
          })

          .catch((error) => {
            reject(error);
          });
      });
    },

    async createDummy({ state, dispatch }, dummySourceData) {
      return new Promise((resolve, reject) => {
        let req = new XMLHttpRequest();
        let formData = new FormData();
        Object.keys(dummySourceData).forEach((key) => formData.append(key, dummySourceData[key]));
        req.open("POST", `${state.apiUrl}contentsources/${dummySourceData.sourceId}/dummydata`);
        req.setRequestHeader("Authorization", "Bearer " + state.token.access_token);
        req.onreadystatechange = function() {
          if (this.readyState == 4) {
            // let response = JSON.parse(this.responseText)
            if (this.status == 200) {
              const res = JSON.parse(this.responseText);
              resolve(res);
            }
            // else reject(this.responseText)
            else reject();
          }
        };
        req.send(formData);
      });
    },

    handleMultiFileUpload({ state, dispatch }, fileData) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`contentsources/${fileData.sourceId}/dummydata/map`, fileData.fileData)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err.error);
          });
      });
    },

    sendExportLink({ state }, exportData) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`templates/${exportData.publicationId}/export`, exportData.exportModel)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    cancelVariableMapping({ state }, fileName) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("contentsources/dummydata/map/cancel", { fileName: fileName })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteDummy({ state, dispatch }, dummySourceData) {
      return new Promise((resolve, reject) => {
        dispatch("showConfirmation", {
          title: i18n.t("delete-modal.delete"),
          description: dummySourceData.dummy.name + "?",
          confirmButtonText: i18n.t("delete-modal.accept"),
        }).then(
          () => {
            Vue.http
              .delete(`contentsources/${dummySourceData.sourceId}/dummydata/${dummySourceData.dummy.id}`)
              .then(() => {
                resolve();
              });
          },
          () => {
            reject();
          },
        );
      });
    },

    editSource({ state }, contentSource) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put("contentsources/" + contentSource.id, JSON.stringify(contentSource), { emulateJSON: true })
          .then((result) => {
            let cSource = state.contentSources2.find((s) => s.id == contentSource.id);
            cSource.dataURL = result.body.dataURL;
            cSource.searchURL = result.body.searchURL;
            cSource.exampleId = result.body.exampleId;
            cSource.name = result.body.name;
            resolve(true);
            return result.body;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deleteSource({ state, dispatch }, contentSource) {
      return new Promise((resolve, reject) => {
        Vue.http
          .delete("contentsources/" + contentSource.id)
          .then(() => {
            state.contentSources2.splice(state.contentSources2.findIndex((t) => t.id == contentSource.id), 1);
            dispatch("getContentSources");
            resolve();
          })
          .catch((e) => {
            reject();
          });
      });
    },

    updateTemplateMetadata({ state }, templateMetadata) {
      return new Promise((resolve, reject) => {
        Vue.http.put("templates/" + templateMetadata.id + "/metadata", templateMetadata).then((result) => {
          state.templates[state.templates.findIndex((t) => t.id === templateMetadata.id)] = result.body;
          return result.body;
        });
      });
    },

    duplicateTemplate({ state, dispatch }, newInfo) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`templates/${newInfo.existingId}/copy?newLanguage=${newInfo.newLanguage}&newName=${newInfo.newName}`, {
            emulateJSON: true,
          })
          .then((result) => {
            resolve(true);
            return dispatch("getTemplates");
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getPublicationStats({ state }, id) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${id}/usage`, { emulateJSON: true })
          .then((result) => {
            state.publicationStats = result.body;
            resolve(result.body);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    sendStatsLink({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(
            `templates/${data.publicationId}/usagereport?timespan=${data.formData.timespan}&email=${
              data.formData.email
            }`,
          )
          .then((result) => {
            resolve(result.body);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getSingleItemStats({ state }, info) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${info.publicationId}/${info.contentId}/usage`, {
            emulateJSON: true,
          })
          .then((result) => {
            if (info.contentId == "") {
              state.publicationSingleItemStats = [];
            } else {
              state.publicationSingleItemStats = result.body;
              resolve(result.body);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getFavorites({ state }) {
      let STORAGE_KEY = "template-" + state.template.metadata.id;
      state.dataFavorites = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    },

    toggleFavorites({ state }, dataSet) {
      let STORAGE_KEY = "template-" + state.template.metadata.id;
      if (state.dataFavorites.some((favorite) => favorite.id == dataSet.id)) {
        state.dataFavorites.splice(state.dataFavorites.findIndex((favorite) => favorite.id == dataSet.id), 1);
      } else {
        state.dataFavorites.push(dataSet);
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.dataFavorites));
    },

    getTemplateBackups({ state }, templateId) {
      state.templateBackups = [];
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${templateId}/backups`)
          .then((result) => {
            state.templateBackups = result.body;
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getBackupInfo({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`templates/${data.templateId}/backups/${data.backupId}`)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    revertTemplate({ state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .put(`templates/${data.templateId}/backups/${data.backupId}/revert`)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    validateResetToken({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`validateresettoken`, data)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    
    createNewPassword({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post(`resetpassword`, data)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    sendResetPassword({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get(`sendresetpasswordmessage/` + data)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    
    getSubscriptionPlans({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get("subscription/plans")
          .then((result) => {
            state.subscriptionPlans = result.body;
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    
    getSetupintent({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get("subscription/setupintent")
          .then((result) => {
            state.setupintent = result.body;
            resolve(result.body);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    createSubscription({ state }, data) {
      return new Promise((resolve, reject) => {
        Vue.http
          .post("organizations/me/subscribe", data)
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getSubscriptions({ state }) {
      return new Promise((resolve, reject) => {
        Vue.http
          .get("organizations/me/subscriptions")
          .then((result) => {
            resolve(result.body);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async getCountry({ state }, searchTerm) {
      return new Promise((resolve, reject) => {
        fetch("https://restcountries.com/v3.1/name/" + searchTerm)
          .then((res) => res.json())
          .then((res) => {
            let resultList = [];
            res.forEach((r) => {
              const country = {
                name: r.name.common,
                cca2: r.cca2,
                flag: r.flags.svg,
              };
              if (state.validCountryCodes.includes(country.cca2)) resultList.push(country);
            });
            resolve(resultList);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },


    async getLanguages({ state }, searchTerm) {
      return new Promise((resolve, reject) => {
        fetch("https://restcountries.com/v3.1/lang/" + searchTerm)
          .then((res) => res.json())
          .then((res) => {
            let resultList = [];
            res.forEach((r) => {
              resultList = resultList.concat(Object.values(r.languages));
            });
            resolve(new Set(resultList));
          })
          .catch((e) => {
            reject(e);
          });
      });
    },



    testSourceConnection({state}, id){
      return new Promise((resolve, reject) => {
        Vue.http.get(`organizations/me/sources/${id}/test`).then(res => {
          resolve(res.body)
        })
      })
    },

    testSourceConnections({state}, ids){
      const params =  ids.map(c => "sourceIds=" + c)
      return new Promise((resolve, reject) => {
        Vue.http.get(`organizations/me/sources/test?${params.join("&")}`).then(res => {
          resolve(res.body)
        })
      })
    },

    getTemplateSettings({state}, id){
      return Vue.http.get(`templates/${id}/settings`).then((result) => result.body);
    },

    getTemplateSettingsFields({state}, id){
      return Vue.http.get(`templates/${id}/settingsfields`).then((result) => result.body);
    },

    saveTemplateSettings({commit}, {id, settings}){
      return new Promise((resolve, reject) => {
        Vue.http.put(`templates/${id}/settings`, settings).then(res => {
          commit("setTemplateSettings", {id, settings})
          resolve(res.body)
        })
      })
    },
    
    addDefaultTemplateSettings({state, dispatch}, template){
      dispatch("getTemplateSettingsFields", template.metadata.id).then((res) => {
        let templateSettings = {}
        res.forEach(e => {
          templateSettings[e.id] = e.default
        });
        dispatch("saveTemplateSettings", { id: template.metadata.id, settings: templateSettings})
      })
    },

    shareDemoLink({state}, data){
      return new Promise((resolve, reject) => {
        Vue.http.post(`demo/share`, data).then(res => {
          console.log(res)
          resolve(res.body)
        }).catch(e => {
          reject(e)
        })
      })
    },
    
    newDemoUser({ dispatch, commit }, data){
      return new Promise((resolve, reject) => {
        Vue.http.post("demo/create", data).then((res) => {
          console.log(res)
          router.push({
            name: "demo",
            params: { demokey: res.body.metadata.demoKey },
            query: { demoType: demoHelper.getDemoTypeUrlParam(res.body.metadata.demoType) }
          });
          commit("saveDemoUserData", res.body);
          dispatch('getDemoVariables', res.body).then(() => {
            resolve(res.body)
          }).catch((e) => {
            reject(e)
          })
        }).catch((e) => {
          // handle error
          reject(e)
        })
      })
    },

    getDemoDataWithKey({ dispatch, commit }, key){
      return new Promise((resolve, reject) => {
        Vue.http.get("demo/template").then((res) => {
          commit("saveDemoUserData", res.body);
          dispatch('getDemoVariables', res.body).then(() => {
            resolve(res.body)
          }).catch((e) => {
            reject(e)
          })
        }).catch((e) => {
          reject(e)
        })
      })
    },

    getDemoVariables({dispatch, commit, state}, template){
      return new Promise((resolve, reject) => {
        dispatch("getVariables", {template: template, isDemo: true}).then((res) => {
          commit("setTemplateData", {
            template: template,
            variables: res
          });
          router.currentRoute.query.seed = Math.floor(Math.random() * 10000) + 1;
          dispatch("getTemplatePreview", {
            template: state.template,
            variables: state.templateVariables,
            generateAIContent: true
          }).then((res) => {
            commit("setTemplatePreview", res)
            dispatch("getVariableFormats", {templateLanguage: template.metadata.language, templateId: template.metadata.id}).then(() => {
              resolve()
            })
          })
        }).catch((e) => {
          reject(e)
        })
      })
    },

    getDemoFavorites({commit}){
      return new Promise((resolve, reject) => {
        Vue.http.get("demo/favorites").then((res) => {
          commit("setDemoFavorites", res.body)
          resolve(res.body)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    signupFromDemo({state}, signupData){
      return new Promise((resolve, reject) => {
        Vue.http.post("organizations", signupData).then((res) => {
          resolve(true)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    testDemoUrl({commit}, urlData){
      return new Promise((resolve, reject) => {
        Vue.http.post("demo/checkurl", urlData).then((res) => {
          resolve(res)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    autoRephraseVariant({state, getters, commit}, data){
      return new Promise((resolve, reject) => {
        commit("setLoadingAiVariantStatus", true)
        const gsynInstancesInVariant = SynonymHelpers.globalSynonymsInText(data.variantText).map(g => SynonymHelpers.getGsynName(g))
        data.globalSynonyms = state.template.globalSynonyms.filter(g => gsynInstancesInVariant.includes(g.name))
        data.dependentVariables = VariableHelpers.getDependentVariables(data.variantText, getters.combinedVariables).reverse()
        data.templateLanguage = state.template.language
        Vue.http.post("editor/variantsuggestions", data).then((res) => {
          resolve(res.body.variants)
        }).catch((e) => {
          reject(e)
        }).finally(() => {
          commit("setLoadingAiVariantStatus", false)
        }) 
      })
    },

    translateAivariant({state, getters}, data){
      const gsynInstancesInVariant = SynonymHelpers.globalSynonymsInText(data.variantText).map(g => SynonymHelpers.getGsynName(g))
      data.globalSynonyms = state.template.globalSynonyms.filter(g => gsynInstancesInVariant.includes(g.name))
      data.dependentVariables = VariableHelpers.getDependentVariables(data.variantText, getters.combinedVariables).reverse()
      data.templateLanguage = state.template.language
      return new Promise((resolve, reject) => {
        Vue.http.post("editor/varianttranslation", data).then((res) => {
          console.log(res)
          resolve(res.body)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    translateAISynonyms({state}, data){
      return new Promise((resolve, reject) => {
        Vue.http.post("editor/synonymtranslation", data).then((res) => {
          console.log(res)
          resolve(res.body)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    getSynonymSuggestions({state}, synonym){
      const data = {
        synonym: synonym,
        amount: state.synonymAmounts,
        templateLanguage: state.template.language
      }
      return new Promise((resolve, reject) => {
        Vue.http.post("editor/synonymsuggestions", data).then((res) => {
          resolve(res.body)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    getAvailableStandardTemplates({state}){
      return new Promise((resolve, reject) => {
        Vue.http.get("templates/standard/list").then((res) => {
          resolve(res.body)
        }).catch((e) => {
          reject(e)
        })
      })
    },

    pushIdsToQueue({state}, data){
      return new Promise((resolve, reject) => {
        Vue.http.post(`templates/${data.id}/push`, {contentIds: data.contentIds}).then((res) => {
          resolve(res);
        }).catch((e) => {
          reject();
        })
      })
    },
    
    async pushFromSpreadsheetToQueue({state}, data){
      return new Promise((resolve, reject) => {
        let req = new XMLHttpRequest();
        let formData = new FormData();
        formData.append("file", data.file)
        req.open("POST", `${state.apiUrl}templates/${data.id}/push`);
        req.setRequestHeader("Authorization", "Bearer " + state.token.access_token);
        req.onreadystatechange = function() {
          if (this.readyState == 4) {
            if (this.status == 200) {
              console.log(this.responseText)
              resolve();
            }
            else reject();
          }
        };
        req.send(formData);
      });
    }
}